
export class HolidaysRequestModel {
  holidayDate : Date;
  updatedUser ?: string;
  versionFlag: number;
}

export const HolidaysRequestDefault: HolidaysRequestModel = {
  holidayDate: new Date(),
  versionFlag: 0,
  updatedUser: '',
}

